import { render } from "./SpecificationExamples.vue?vue&type=template&id=d5648dae"
import script from "./SpecificationExamples.vue?vue&type=script&lang=js"
export * from "./SpecificationExamples.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__